import { ButtonColor } from "../../basic/button";
import { Column } from "./column";

// export type ButtonColor = "darkBlue" | "red" | "green" | "darkGreen" | "lightBlue" | "darkYellow";

export class ButtonColumn<T> extends Column<T> {
	public onClick?: (row: T) => void;
	public buttonText?: string;
	public color?: ButtonColor;

	constructor(name: string, propertyName?: keyof T | string) {
		super(name, propertyName);
		this.withFullObject(true);
	}

	public withOnClick(onClick: (row: T) => void) {
		this.onClick = onClick;
		return this;
	}

	public withButtonText(text: string) {
		this.buttonText = text;
		return this;
	}

	public withButtonColor(color: ButtonColor) {
		this.color = color;
		return this;
	}
}
